var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"div-successfulbooking"},[_c('h2',[_c('v-icon',{attrs:{"color":"green","large":""}},[_vm._v("mdi-check")]),_vm._v(" Ihre Buchung war erfolgreich! ")],1),_c('br'),_c('h3',[_vm._v("Sie werden jetzt automatisch weitergeleitet!")]),_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":50,"width":7}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }